'use strict';

var gridTD = function () {
  var _controlGridItems = function _controlGridItems(selector) {
    var $elem = $(selector),
        arrayIDs = [];

    $elem.each(function (index) {
      var $me = $(this);
      var currentID = $me.attr('data-nid');
      if (arrayIDs.indexOf(currentID) === -1) {
        arrayIDs.push(currentID);
        $me.removeClass('hidden');
      } else {
        $me.addClass('hidden');
      }
    });
  };
  return {
    controlGridItems: _controlGridItems
  };
}();